<template>
  <div class="container-fluid new_Header">
    <nav class="nav_Breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item mx-3"><router-link  to="/">{{$t('rentalDetails.breadcrumb_1')}}</router-link></li>
        <i v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
        <i v-else class="fa-solid fa-chevron-right pt-1"></i>
        <li class="active mx-3 almarai-bold" aria-current="page">{{$t('rentalDetails.breadcrumb_2')}}</li>
      </ol>
    </nav>
  </div>
  <div class="container pt-3">
    <div class="row">
      <div class="col-12">
        <errorAlert v-if="hasError" :alertMessage="message" />
        <div class="text-center" v-if="isLoading">
          <mainloader />
        </div>
        <div v-else class="row pt-3 justify-content-center">
          <div class="col-12 algin-content-center">
            <swiper :modules="modules" :pagination="{ clickable: true }" :spaceBetween="10"
              :thumbs="{ swiper: thumbsSwiper }" :navigation="true" :autoplay="{ delay: 2500, disableOnInteraction: false,}"
              :style="{'--swiper-navigation-color': '#fff','--swiper-pagination-color': '#fff',}" class="br-radius"
            >
              <swiper-slide style="position:relative" v-for="(gllary, index) in containerMedia" :key="index">
                <!-- <span class="favorite" v-if="row.Favorites && row.Favorites.length" @click.prevent="removeFavorite(row.id, 'row.mediaFiles', index)">
                  <i class="fa-solid fa-heart favorite-icon-remove"></i>
                </span>
                <span  class="favorite" v-else @click.prevent="addFavorite(row.id, 'row.mediaFiles', index)">
                  <i class="fa-solid fa-heart favorite-icon"></i>
                </span> -->
                <img :src="MEDIA_URL+gllary.filePath" alt="Slide Image" class="w-100 max-h" />
              </swiper-slide>
            </swiper>

            <swiper @swiper="setThumbsSwiper" :spaceBetween="10" :slidesPerView="4" 
              :freeMode="true"
              :watchSlidesProgress="true"
              :modules="modules"
              class="pt-3 mouse-hand"
            >
              <swiper-slide v-for="(image,indx) in containerMedia" :key="indx">
                <img :src="MEDIA_URL+image.thumbnail" class="img-fluid br-radius" alt="">
              </swiper-slide>
            </swiper>

            <div class="row pt-3">
              <div class="col-12 col-md-8 button-center">
                <div class="fonttext-14 almarai-regular text-end">{{row.title}}</div>
                <div class="gray-color d-flex fonttext-14 pt-1">
                  <i class="fa-solid fa-location-dot pt-1"></i>
                  <div class="me-1">{{row.City.name}}</div>
                  <div class="mx-1">{{row.Neighborhood.name}}</div>
                </div>
              </div>
            </div>
            <hr class="line-color">

            <div class="row pt-3">
              <div class="col">
                <h6 class="almarai-bold">{{$t('rentalDetails.propertyDetails')}}</h6>

                <div class="row pt-3">
                  <div class="col-12 col-md-3 total_Units">
                    <div class="card bg-grayD2">
                      <div class="card-body">
                        <div class="row">
                          <div class="col almarai-bold">
                            <div>
                              {{soldProperties.length + availableProperties.length + rentedProperties.length}}
                            </div>
                            <div>{{$t('rentalDetails.totalUnits')}}</div>
                          </div>
                          <div class="col-auto content-end">
                            <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1 font-12"></i>
                            <i  v-else class="fa-solid fa-chevron-right pt-1 font-12"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-4 col-md-3">
                    <div class="card bg-color-2B">
                      <div class="card-body">
                        <div class="row">
                          <div class="col almarai-bold">
                            <div>
                              {{availableProperties.length}}
                            </div>
                            <div>{{$t('rentalDetails.vacancies')}}</div>
                          </div>
                          <div class="col-auto content-end">
                            <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1 font-12"></i>
                            <i  v-else class="fa-solid fa-chevron-right pt-1 font-12"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-4 col-md-3">
                    <router-link to="/allProperties">
                      <div class="card landlord">
                        <div class="card-body">
                          <div class="row">
                            <div class="col almarai-bold">
                              <div>{{rentedProperties.length}}</div>
                              <div class="almarai-bold">{{$t('rentalDetails.landlord')}}</div>
                            </div>
                            <div class="col-auto content-end">
                              <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1 font-12"></i>
                              <i  v-else class="fa-solid fa-chevron-right pt-1 font-12"></i>
                            </div>
                          </div>
                        </div>
                      </div>
                    </router-link>
                  </div>
                  <div class="col-4 col-md-3">
                    <div class="card sold">
                      <div class="card-body">
                        <div class="row">
                          <div class="col">
                            <div class="almarai-bold">{{soldProperties.length}}</div>
                            <div class="almarai-bold">{{$t('rentalDetails.sold')}}</div>
                          </div>
                          <div class="col-auto content-end">
                            <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1 font-12"></i>
                            <i  v-else class="fa-solid fa-chevron-right pt-1 font-12"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>  
            </div>
            
            <div class="row pt-3">
              <div class="almarai-bold py-2">{{$t('rentalDetails.PropertyManager')}}</div>
              <div class="col-3 col-md-auto">
                <div class="agent-logo">
                  <img src="/assets/images/icons/image.png" class="w-100" alt="">
                </div>
              </div>
              <div class="col-8 col-md-auto content-end">
                <div class="almarai-regular pb-2">
                  {{$t('rentalDetails.Ahmed_AlMuhaisni_Company')}}
                </div>
                <span class="almarai-regular agent-color">{{$t('rentalDetails.PropertyManager')}}</span>
              </div>
            </div>

            <h6 class="almarai-bold pt-5">{{$t('rentalDetails.title_2')}}</h6>
            <div class="row pt-2">
              <div class="col-6 col-md-4" v-if="row.totalOfRents">
                <div class="row pt-2">
                  <div class="col-auto ps-0">
                    <img src="/assets/images/icons/money.png" class="max-40" alt="">
                  </div>
                  <div class="col-auto">
                    <span class="text-style"> {{$t('property.rentalValue')}} </span><br>
                    <span class="green-2B almarai-bold">{{row.totalOfRents}} <span class="mx-1 green-color-F icon-saudi_riyal_bold_new"></span></span>
                  </div>
                </div>
              </div>
              <div class="col-6 col-md-4">
                <div class="row pt-2">
                  <div class="col-auto ps-0">
                    <img src="/assets/images/icons/Frame-8.png" class="max-40" alt="">
                  </div>
                  <div class="col-auto">
                    <span class="text-style">{{$t('rentalDetails.paid')}}</span><br>
                    <span class="green-2B almarai-bold">{{row.collectedAmount}} <span class="mx-1 green-color-F icon-saudi_riyal_bold_new"></span></span>
                  </div>
                </div>
              </div>
            </div>

            <div class="row pt-2">
              <div class="col-6 col-md-4 content-center">
                <div class="row">
                  <div class="col-auto">
                    <img src="/assets/images/icons/frame_plus.png" class="max-40" alt="">
                  </div>
                  <div class="col p-0">
                    <span class="text-style">{{$t('rentalDetails.title_6')}}</span><br>
                    <span v-if="row.nextPayment"  class="gray-color-60 almarai-bold">{{moment(row.nextPayment).format('DD / MM /YYYY')}}</span>
                    <span v-else class="almarai-bold">{{$t('nothing')}}</span>
                  </div>
                </div>
              </div>
              <div class="col-6 col-md-4">
                <div class="row pt-2">
                  <div class="col-auto ps-0">
                    <img src="/assets/images/icons/Frame-8.png" class="max-40" alt="">
                  </div>
                  <div class="col-auto">
                    <span class="text-style">{{$t('containerRet.latePayments')}}</span><br>
                    <span class="almarai-bold latePay_color">{{row.latePayments}} <span class="mx-1 latePay_color icon-saudi_riyal_bold_new"></span></span>
                  </div>
                </div>
              </div>

              <div class="col-6 col-md-4">
                <div class="row">
                  <div class="col-auto ps-0">
                    <img src="/assets/images/icons/Frame-5.png" class="max-40" alt="">
                  </div>
                  <div class="col-auto">
                    <span class="text-style">{{$t('rentalDetails.title_4')}}</span><br>
                    <span class="gray-color-60 almarai-bold">{{row.remainingPayments}} <span class="mx-1 icon-saudi_riyal_bold_new"></span></span>
                  </div>
                </div>
              </div>
            </div>
            <!-- begin: Units within the property -->
            <div class="row pt-3">
              <div class="col">
                <div class="row">
                  <div class="col content-center">
                    <h6 class="almarai-bold mb-0">{{$t('containerRet.unitsProperty')}}</h6>
                  </div>
                  <div class="col-auto trackOrder" @click="popupViewAll">
                    {{$t('viewAll')}}
                  </div>
                </div>
                <div class="row pt-3" v-for="(pro,indexkey) in Properties.slice(0, 3)" :key="`P_${pro.indexkey}`">
                  <div class="col-12">
                    <div class="accordion bg-accordionR" :id="pro.id">
                      <div class="accordion-item">
                        <h2 class="accordion-header accordion-bg">
                          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" :data-bs-target="`#collapse${pro.id}`" aria-expanded="false" :aria-controls="`collapse${pro.id}`">
                            {{pro.title}}
                          </button>
                        </h2>
                        <div :id="`collapse${pro.id}`" class="accordion-collapse collapse" :data-bs-parent="pro.id">
                          <div class="accordion-body">
                            <div class="row pt-2">
                              <div v-if="pro.User" class="col-4">
                                <div class="text-style">{{$t('containerRet.rentalName')}}</div>
                                <div>{{pro.User.name}}</div>
                              </div>
                              <div class="col-4">
                                <div class="text-style">{{$t('containerRet.propertyStatus')}}</div>
                                <div>{{statusChoices[pro.status]}}</div>
                              </div>
                              <div class="col-auto">
                                <span class="text-style">{{$t('property.rentalValue')}}</span><br>
                                <span class="green-2B almarai-bold">{{row.collectedAmount}} <span class="mx-1 green-color-F icon-saudi_riyal_bold_new"></span></span>
                              </div>
                            </div>
                            <div class="row pt-2 justify-content-end">
                              <div class="col-auto">
                                <router-link :to="'/propertydetails/'+pro.id+'?m=1&a=1&propertyType=property'">
                                  <div class="btn_unitsDetails">{{$t('containerRet.propertyDetails')}}</div>
                                </router-link>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- end: Units within the property -->

            <!--begin:location-->
            <div class="row pt-3" v-if="row.latitude && row.longitude && parseFloat(row.latitude) && parseFloat(row.longitude)">
              <div class="col">
                <div class="almarai-bold py-2">{{$t('rentalDetails.title_9')}}</div>
                <div ref="myMap" style="width: 100%; height: 350px;"></div>
              </div>
            </div>
            <!--end:location-->
          </div>

          <!-- begin: lawyer Requested & Contact customer service & finance Request -->
          <div class="row pt-3 justify-content-center">
            <div class="col-6 contact-S">
              <a :href="`https://wa.me/+966920016962?text= ${customer_ServiceMessage}`" target="_blank">
                <div class="card contactService">
                  <div class="card-body">
                    <div class="d-block d-md-none">
                        <img src="/assets/images/icons/call-calling.png" alt="">
                      </div>
                      <span class="d-none d-md-block">
                        <img src="/assets/images/icons/call-calling.png" alt="">
                        <span class="mx-2">{{$t('contactService')}} {{$t('customers')}}</span>
                      </span>
                      <div class="d-block d-md-none">{{$t('contactService')}} {{$t('customers')}}</div>
                  </div>
                </div>
              </a>
            </div>
            <div class="col-6 text-center">
              <router-link :to="'/lawyerRequested/'+containerID+'?propertyType=property'">
                <div class="card contactLawyer">
                  <div class="card-body">
                    <div class="row justify-content-center">
                      <div class="col-auto d-block d-md-none content-center text-center">
                        <img src="/assets/images/icons/lawyer-icon.png" class="lawyer-logo" alt="">
                      </div>
                      <div class="almarai-bold d-block d-md-none">{{$t('contactLawyer')}}</div>
                      <span class="d-none lawyer-style d-md-block">
                        <img src="/assets/images/icons/lawyer-icon.png" class="lawyer-logo" alt="">
                        <span class="mx-2">{{$t('contactLawyer')}}</span>
                      </span>
                    </div>
                  </div>
                </div>
              </router-link>
            </div>
          </div>

          <div class="row pt-3">
            <div class="col-12 finance_Card">
              <div class="card requestFinance">
                <div class="card-body">
                  <div class="row justify-content-center">
                    <div class="col-8 col-md-8 finance_text">
                      <div>{{$t('needFinancing')}}</div>
                      <div>{{$t('manageObligations')}}</div>
                      <div class="row pt-3 finance_text">
                        <div class="col-9 col-md-5 btn_requestFinance">
                          <router-link :to="'/createfinance/'+containerID">
                          <span class="text_btn">{{$t('ApplyFnancing')}}</span>
                          </router-link>
                        </div>
                      </div>
                    </div>
                    <div class="col-4 col-md-4 content-center text-direction">
                      <img src="/assets/images/Vector.png" class="img_requestFinance" alt="">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- end: lawyer Requested & Contact customer service & finance Request -->

          <section class="pt-3">
            <div class="row">
              <div class="col">
                <h5 class="almarai-bold">{{$t('propertydetails.propertyDocuments')}}</h5>
              </div>
              <div class="col-auto viewDoc" v-if="propertyAttachments.length" @click="viewDocuments">
                <span class="mx-2">{{$t('property.viewDocuments')}}</span>
                <i v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1 font-12"></i>
                <i v-else class="fa-solid fa-chevron-right pt-1 font-12"></i>
              </div>
            </div>
            <div class="row pt-4">
              <div class="col">
                <div class="row">
                  <div class="col-auto ps-0">
                    <img src="/assets/images/icons/Frame-4.png" class="width-40" alt="">
                  </div>
                  <div class="col pe-0">
                    <div class="mx-2 text-style">{{$t('propertydetails.deedNumber')}}</div>
                    <div v-if="row.deedNumber" class="pe-2">{{row.deedNumber}}</div>
                    <div v-else class="pe-2 almarai-bold">{{$t('nothing')}}</div>
                  </div>
                </div>
              </div>
              <div class="col">
                <div class="row">
                  <div class="col-auto ps-0">
                    <img src="/assets/images/icons/Frame-3.png" class="width-40" alt="">
                  </div>
                  <div class="col pe-0">
                    <div class="text-style mx-2">{{$t('propertydetails.identityImage')}}</div>
                    <div class="orange-color pe-2 almarai-bold">{{$t('propertydetails.Viewimage')}}</div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row py-4">
              <div class="col">
                <div class="row">
                  <div class="col-auto ps-0">
                    <img src="/assets/images/icons/Frame-2.png" class="width-40" alt="">
                  </div>
                  <div class="col pe-0">
                    <div class="mx-2 text-style">{{$t('propertydetails.buildingLicence')}}</div>
                    <div class="pe-2 almarai-bold orange-color">{{$t('propertydetails.viewLicence')}}</div>
                  </div>
                </div>
              </div>
              <div class="col">
                <div class="row">
                  <div class="col-auto ps-0">
                    <img src="/assets/images/icons/Frame-413.png" class="width-40" alt="">
                  </div>
                  <div class="col pe-0">
                    <div class="text-style mx-2">{{$t('propertydetails.civilDefense')}}</div>
                    <div class="orange-color pe-2 almarai-bold">{{$t('propertydetails.viewcertificate')}}</div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <div class="row pt-5 justify-content-center">
            <div class="col-12 col-md-5"  data-bs-toggle="modal" data-bs-target="#exampleModal">
              <div class="btn-green">{{$t('propertydetails.newMaintenance')}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal-begin:maintenances -->
    <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <!-- <div class="modal-header">
            <button type="button" class="btn-close" id="maintenanceClose" data-bs-dismiss="modal" aria-label="Close"></button>
          </div> -->
          <div class="modal-body">
            <div class="row pt-3">
              <router-link to="/maintenances/?type=global" @click="exitForm">
                <div class="col btn-white">
                  <div class="almarai-bold">{{$t('Free_owners_tenants')}}</div>
                  <span class="text-center almarai-regular text-style">{{$t('dedicated_Maintenance')}}</span>
                </div>
              </router-link>
            </div>

            <div class="row pt-3">
              <router-link to="/maintenances/?type=normal" @click="exitForm">
                <div class="col btn-black">
                  <div class=" almarai-bold">{{$t('requestMaintenance')}}</div>
                  <span class="text-center almarai-regular text-white">{{$t('Within_24hours')}} {{ normalOrderPrice }} {{$t('addAd.real')}}</span>
                </div>
              </router-link>
            </div>

            <div class="row pt-3">
              <router-link to="/maintenances/?type=fast" @click="exitForm">
                <div class="col btn-white">
                  <div class=" almarai-bold">{{$t('requestExpress_maintenance')}}</div>
                  <span class="text-center almarai-regular text-style">{{$t('Within_120Minutes')}} {{ fastOrderPrice }} {{$t('addAd.real')}}</span>
                </div>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal-end:maintenances -->

    <!-- begin: view documents -->
    <div class="modal bg-modal" tabindex="-1" id="viewDocumentsPopup">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <div class="row py-2">
              <div class="col almarai-bold">
                <span class="mx-2 fonttext-14">{{$t('property.viewDocuments')}}</span>
              </div>
              <div class="col-auto mouse-hand" id="closeModal" @click="close_Popup" data-bs-dismiss="modal" aria-label="Close">
                <i class="fa-regular fa-circle-xmark fs-5 gray-color"></i>
              </div>
            </div>

            <div class="row pt-3" v-if="propertyAttachments.length">
              <div class="col content-center">
                <div class="row mb-3" v-for="(pro,index) in propertyAttachments" :key="index">
                  <div class="col content-center">
                    <div class="gray-color almarai-bold">{{pro.name}}</div>
                    <!-- <div class="card borderCard">
                      <div class="card-body">
                        <div>
                          <img :src="MEDIA_URL+featured.icon" class="max-width-28" alt="">
                        </div>
                      </div>
                    </div> -->
                  </div>
                  <div class="col-auto btn-gold-samll" v-if="pro.fileType == 'pdf'">
                    <a :href="MEDIA_URL+pro.path" class="text-white" target="_blank">
                      <span class="mx-2">{{$t('viewDocuments')}}</span>
                    </a>
                  </div>
                  <div v-else class="col-auto btn-gold-samll" @click="openViewDocument">
                    <span class="mx-2">{{$t('viewDocuments')}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end: view documents -->

    <!-- begin: view documents image  -->
    <div class="modal bg-modal" tabindex="-1" id="viewImage">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <div class="row py-2">
              <div class="col almarai-bold">
                <span class="mx-2 fonttext-14">{{$t('property.viewDocuments')}}</span>
              </div>
              <div class="col-auto mouse-hand" id="closeModal" @click="closePopup" data-bs-dismiss="modal" aria-label="Close">
                <i class="fa-regular fa-circle-xmark fs-5 gray-color"></i>
              </div>
            </div>

            <div class="row pt-3 justify-content-center" v-if="propertyAttachments.length">
              <div class="col-12 mb-3 text-center content-center" v-for="(prop,indxf) in propertyAttachments" :key="indxf" >
                <img v-if="prop.fileType == 'image'" :src="MEDIA_URL+prop.path" alt="">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end: view documents image -->

    <!-- Button trigger modal -->
    <button type="button" class="hidden-fileds" id="btn_viewAll" data-bs-toggle="modal" data-bs-target="#propertiesID">
      Launch demo modal
    </button>

    <!-- Modal -->
    <div class="modal fade" id="propertiesID" tabindex="-1" aria-labelledby="propertiesIDLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <div class="row btn-closed">
              <div class="col-auto mouse-hand" @click.prevent="closeForm" id="closeModal" data-bs-dismiss="modal" aria-label="Close">
                <i class="fa-regular fa-circle-xmark fs-5 gray-color"></i>
              </div>
            </div>
            <div class="row pt-3" v-for="(prop,indexP) in Properties" :key="`I_${prop.indexP}`">
              <div class="col-12">
                <div class="accordion bg-accordionR" :id="prop.id">
                  <div class="accordion-item">
                    <h2 class="accordion-header accordion-bg">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" :data-bs-target="`#collapse${prop.id}`" aria-expanded="false" :aria-controls="`collapse${prop.id}`">
                        {{prop.title}}
                      </button>
                    </h2>
                    <div :id="`collapse${prop.id}`" class="accordion-collapse collapse bg-accordionR" :data-bs-parent="prop.id">
                      <div class="accordion-body">
                        <div class="row pt-2">
                          <div v-if="prop.User" class="col-4">
                            <div class="text-style">{{$t('containerRet.rentalName')}}</div>
                            <div>{{prop.User.name}}</div>
                          </div>
                          <div class="col-4">
                            <div class="text-style">{{$t('containerRet.propertyStatus')}}</div>
                            <div>{{statusChoices[prop.status]}}</div>
                          </div>
                          <div class="col-auto">
                            <span class="text-style">{{$t('property.rentalValue')}}</span><br>
                            <span class="green-2B almarai-bold">{{row.collectedAmount}} <span class="mx-1 green-color-F icon-saudi_riyal_bold_new"></span></span>
                          </div>
                        </div>
                        <div class="row pt-2 justify-content-end">
                          <div class="col-auto">
                            <router-link :to="'/propertydetails/'+prop.id+'?m=1&a=1&propertyType=property'">
                              <div class="btn_unitsDetails">{{$t('containerRet.propertyDetails')}}</div>
                            </router-link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { ref } from 'vue';
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import 'swiper/css/free-mode';
import 'swiper/css/thumbs';
import { Pagination, Navigation, FreeMode, Thumbs, Autoplay } from "swiper/modules";
import { mapGetters } from "vuex";
import moment from 'moment';
export default {
  name: "containerRetrieve",
  setup(){
    const thumbsSwiper = ref(null);
    const setThumbsSwiper = (swiper) => {
      thumbsSwiper.value = swiper;
    };
    return {
      thumbsSwiper,
      setThumbsSwiper,
      modules: [FreeMode, Thumbs, Navigation, Pagination, Autoplay],
    }
  },

  data(){
    return{
      isLoading: true,
      hasError: false,
      message: "",
      errorNumber: null,
      containerID: this.$route.params.id,
      containerMedia:[],
      Properties: [],
      row: {},
      statusChoices: {},
      rentedProperties: [],
      availableProperties: [],
      soldProperties: [],
      normalOrderPrice: null,
      fastOrderPrice: null,
      propertyAttachments: [],
      userLang: "ar",
      customer_ServiceMessage: this.$t('customer_ServiceMessage'),
    }
  },

  components: { Swiper, SwiperSlide },

  computed:{
    ...mapGetters(["GET_USER",'MEDIA_URL'])
  },

  methods:{
    containerDetails(){
      this.$http.get('/api/properties/containerRetrieve/'+this.containerID+'/?management=1').then(res => {
        this.row = res.data.row;
        this.containerMedia = res.data.row.PropertyContainerMedia;
        this.propertyAttachments = res.data.row.PropertyAttachments;
        this.Properties = res.data.row.Properties;
        this.statusChoices = res.data.statusChoices;
        this.rentedProperties = res.data.rentedProperties;
        this.availableProperties = res.data.availableProperties;
        this.soldProperties = res.data.soldProperties;
        if(this.row.latitude && this.row.longitude){
          this.initialGoogleMap();
        }
        this.getDatainitial();
        this.isLoading = false;
      }).catch(err => {
        console.log(err);
        
      })
    },

        initMap(){
      if (!this.$refs.myMap) {
        setTimeout(() => this.initMap(), 200);
        return;
      }
      if (!window.google) {
        console.error("Google Maps API is not loaded.");
        return;
      }
      // Initialize Map
      this.map = new google.maps.Map(this.$refs.myMap, {
        center: { 
          lat: (this.row.latitude) ? parseFloat(this.row.latitude) :24.7136, 
          lng: (this.row.longitude) ? parseFloat(this.row.longitude) : 46.6753, 
        },
        zoom: 8,
      });

      // Create a Marker
      this.marker = new google.maps.Marker({
        position: { 
          lat: (this.row.latitude)? parseFloat(this.row.latitude) : 24.7136, 
          lng: (this.row.longitude) ? parseFloat(this.row.longitude) : 46.6753 
        },
        map: this.map,
        draggable: false, // Allow dragging the marker
      });
        // console.log(parseFloat(this.row.latitude));
    },

    viewDocuments(){
      document.getElementById('viewDocumentsPopup').style.display = 'block';
    },

    close_Popup(){
      document.getElementById('viewDocumentsPopup').style.display = 'none';
    },

    openViewDocument(){
      document.getElementById('viewDocumentsPopup').style.display = 'none';
      document.getElementById('viewImage').style.display = 'block';
    },

    closePopup(){
      document.getElementById('viewImage').style.display = 'none';
    },


    initialGoogleMap(){
      if (!window.google) {
        const script = document.createElement("script");
        script .src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyCmKIguViZj4DtgCcT2Wv8pstx0ynuHMWg&loading=async&libraries=places&callback=initMap`
        script.async = true;
        document.head.appendChild(script);
        window.initMap = this.initMap;
      } else {
        this.initMap();
      }
    },

    moment,
    formatDate(){
      if(this.userLang == 'ar'){
        moment.locale(this.formatedDate);
      }else{
        moment.locale(this.fallbackLang);
      }
      this.nowTime = new Date();
      this.hours = this.nowTime.getHours().toString().padStart(2, '0');
      this.minutes = this.nowTime.getMinutes().toString().padStart(2, '0');
      this.formattedTime = `${this.hours}:${this.minutes}`;
      // console.log(this.formattedTime);
    },

    exitForm(){
      const modal = bootstrap.Modal.getInstance(
        document.getElementById('exampleModal')
      );
      modal.hide();
    },
    getDatainitial(){
      this.hasError = false;
      this.$http.get("/api/orders/init").then(res => {
        // console.log(res);
        this.normalOrderPrice = res.data.normalOrderPrice;
        this.fastOrderPrice = res.data.fastOrderPrice;
        window.scroll(0,0);
        this.isLoading = false;
      }).catch(err => {
        // console.log(err);
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        this.isLoading = false;
        window.scroll(0,0);
      });
    },
    popupViewAll(){
      document.getElementById('btn_viewAll').click();
    }
  },
  created(){
    this.containerDetails();
    window.scrollTo({top:0, behavior:'smooth'});
    this.userLang = localStorage.getItem('lang') ?? 'ar';
  }
}
</script>
<style scoped>
  .accordion-button:not(.collapsed) {
  background-color: #FFFAEB;
  border: 1px solid #AA9359 !important;
  }
  .accordion-collapse.show .accordion-body {
    background-color: #FFFAEB !important;
  }
</style>